const stacks = [
  { id: 21, name: 'Newest' },
  { id: 2, name: 'Web' },
  { id: 3, name: 'Mobile' },
  { id: 4, name: 'Web3' },
  { id: 5, name: 'AI' }
]

export default stacks
